// projects/humanresources-personnel/src/assets/i18n/*/hr-per-exam.json
export class HrPerExamKey {
    private static readonly keyPrefix = 'hrPerExam';
    public static title = `${HrPerExamKey.keyPrefix}.title`;
    public static pageHeader = `${HrPerExamKey.keyPrefix}.pageHeader`;
    public static grade = `${HrPerExamKey.keyPrefix}.grade`;
    public static typeId = `${HrPerExamKey.keyPrefix}.typeId`;
    public static examDate = `${HrPerExamKey.keyPrefix}.examDate`;
    public static validityEndDate = `${HrPerExamKey.keyPrefix}.validityEndDate`;
}
